window.addEventListener('DOMContentLoaded', (event) => {
  const sentProducts = new Set() // Registro de productos ya enviados
  const sentRebuiltProducts = new Set() // Registro de productos rebuilt ya enviados

  const onElementVisible = (elements, callback) => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        let visibleProducts = []

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const productElement = entry.target
            const productData = JSON.parse(
              productElement.querySelector('[data-product-json]')?.innerHTML,
            )

            if (!sentProducts.has(productData.id)) {
              sentProducts.add(productData.id) // Marcar el producto como enviado
              visibleProducts.push({
                item_id: productData.id,
                item_name: productData.title,
                coupon: '',
                discount: productData.compare_at_price
                  ? (Number(productData.compare_at_price) - Number(productData.price)) / 100
                  : 0,
                index: Array.from(elements).indexOf(productElement) + 1,
                item_brand: productData.vendor,
                item_category:
                  productElement.querySelector('[data-product-json]').dataset.category1,
                item_category2:
                  productElement.querySelector('[data-product-json]').dataset.category2,
                item_category3: productData.compare_at_price
                  ? ((Number(productData.compare_at_price) - Number(productData.price)) /
                      Number(productData.compare_at_price)) *
                    100
                  : 0,
                item_category4: productElement.querySelector('[data-product-json]').dataset.size,
                item_category5:
                  productElement.querySelector('[data-product-json]').dataset.category3,
                item_list_id: productElement.closest('.js-product-grid')?.dataset.collectionId,
                item_list_name:
                  productElement.closest('.js-product-grid')?.dataset.collectionHandle,
                item_variant: productElement
                  .querySelector('[data-product-json]')
                  .dataset.colors.toString(),
                price: Number(productData.price) / 100,
                quantity: 1,
                style_number: productElement.querySelector('[data-product-json]').dataset
                  .styleNumber
                  ? productElement.querySelector('[data-product-json]').dataset.styleNumber
                  : '',
                sku_id: productElement.querySelector('[data-product-json]').dataset.sku
                  ? productElement.querySelector('[data-product-json]').dataset.sku
                  : '',
                variant_id: productElement.querySelector('[data-product-json]').dataset.variantId
                  ? productElement.querySelector('[data-product-json]').dataset.variantId
                  : '',
              })
            }
          }
        })

        if (visibleProducts.length > 0) {
          callback(visibleProducts)
        }
      },
      { threshold: 0.2 },
    )

    elements.forEach((element) => observer.observe(element))
  }

  const onRebuiltElementVisible = (elements, callback) => {
    const observer = new IntersectionObserver(
      (entries, observer) => {
        let visibleProducts = []

        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const productElement = entry.target

            if (!sentRebuiltProducts.has(productElement.dataset.productId)) {
              sentRebuiltProducts.add(productElement.dataset.productId) // Marcar el producto como enviado
              visibleProducts.push({
                item_id: productElement.dataset.productId,
                item_name: productElement.dataset.productTitle,
                coupon: '',
                discount: Number(productElement.dataset.productDiscount) || 0,
                index: Array.from(elements).indexOf(productElement) + 1,
                item_brand: productElement.dataset.productBrand,
                item_category: productElement.dataset.productCategory1,
                item_category2: productElement.dataset.productCategory2,
                item_category3: Number(productElement.dataset.productCategory3) || 0,
                item_category4: productElement.dataset.productCategory4,
                item_category5: productElement.dataset.productCategory5,
                item_list_id: productElement.closest('.js-product-grid')?.dataset.collectionId,
                item_list_name:
                  productElement.closest('.js-product-grid')?.dataset.collectionHandle,
                item_variant: productElement.dataset.colorPack,
                price: Number(productElement.dataset.productPrice) || 0,
                quantity: 1,
              })
            }
          }
        })

        if (visibleProducts.length > 0) {
          callback(visibleProducts)
        }
      },
      { threshold: 0.2 },
    )

    elements.forEach((element) => observer.observe(element))
  }

  const checkElement = () => {
    const collectionGrid = document.querySelector('.js-product-grid')

    if (collectionGrid) {
      const productCards = collectionGrid.querySelectorAll('product-card')
      const rebuiltProductCards = collectionGrid.querySelectorAll('rebuilt-product-card')

      onElementVisible(productCards, (visibleProducts) => {
        const customerData = JSON.parse(document.querySelector('.js-customer-json')?.innerHTML)
        const templateData = JSON.parse(document.querySelector('.js-template-json')?.innerHTML)
        const collectionHandle = collectionGrid.dataset.collectionHandle
        const collectionId = collectionGrid.dataset.collectionId

        if (templateData.name == 'index') {
          page_type = 'homepage'
        } else if (templateData.name == 'collection') {
          page_type = 'collection page'
        } else if (templateData.name == 'product') {
          page_type = 'product detail page'
        } else if (templateData.name == 'page') {
          if (templateData.suffix == 'add-more-save-more') {
            page_type = 'bundle builder'
          } else {
            page_type = templateData.suffix || 'other'
          }
        } else {
          page_type = templateData.suffix || 'other'
        }

        const viewItemListDataObject = {
          event: 'view_item_list',
          membership_status: customerData.membership_status,
          ...window.intelligemsMeta,
          ...(customerData.id && { userId: customerData.id }),
          login_status: customerData.has_account ? 'loggedin' : 'non_loggedin',
          page_type: page_type,
          ecommerce: {
            item_list_id: collectionId,
            item_list_name: collectionHandle,
            currency: templateData.currency,
            items: visibleProducts,
          },
        }

        window.dataLayer = window.dataLayer || []
        dataLayer.push({ ecommerce: null })
        dataLayer.push(viewItemListDataObject)
      })

      onRebuiltElementVisible(rebuiltProductCards, (visibleProducts) => {
        const customerData = JSON.parse(document.querySelector('.js-customer-json')?.innerHTML)
        const templateData = JSON.parse(document.querySelector('.js-template-json')?.innerHTML)
        const collectionHandle = collectionGrid.dataset.collectionHandle
        const collectionId = collectionGrid.dataset.collectionId

        if (templateData.name == 'index') {
          page_type = 'homepage'
        } else if (templateData.name == 'collection') {
          page_type = 'collection page'
        } else if (templateData.name == 'product') {
          page_type = 'product detail page'
        } else if (templateData.name == 'page') {
          if (templateData.suffix == 'add-more-save-more') {
            page_type = 'bundle builder'
          } else {
            page_type = templateData.suffix || 'other'
          }
        } else {
          page_type = templateData.suffix || 'other'
        }

        const viewItemListDataObject = {
          event: 'view_item_list',
          membership_status: customerData.membership_status,
          intelligems_meta: window.intelligemsMeta || {},
          ...(customerData.id && { userId: customerData.id }),
          login_status: customerData.has_account ? 'loggedin' : 'non_loggedin',
          page_type: page_type,
          ecommerce: {
            item_list_id: collectionId,
            item_list_name: collectionHandle,
            currency: templateData.currency,
            items: visibleProducts,
          },
        }

        window.dataLayer = window.dataLayer || []
        dataLayer.push({ ecommerce: null })
        dataLayer.push(viewItemListDataObject)
      })

      clearInterval(intervalId)
    }
  }

  const intervalId = setInterval(checkElement, 1000)
})

class InfiniteProductGrid extends HTMLElement {
  constructor() {
    super()
    this.loading = false
    this.fetchLimit = this.dataset.fetchLimit

    const onScrollHandler = this.onScrollHandler
    window.addEventListener('scroll', onScrollHandler.bind(this))
  }

  onScrollHandler() {
    const pagination = this.querySelector('.pagination-wrapper')
    if (pagination === null) {
      return
    }
    if (
      window.innerHeight + window.scrollY >= pagination.offsetTop - 500 &&
      this.loading === false
    ) {
      if (this.fetchLimit <= 0) {
        return
      }
      this.fetchLimit--
      this.loadMoreProducts()
    }
  }

  loadMoreProducts() {
    const pagination = this.querySelector('.pagination-wrapper')
    if (pagination === null) {
      return
    }
    this.loading = true
    this.classList.add('loading')
    const paginationLinkElement = pagination
      .querySelector('span.current')
      ?.nextElementSibling?.querySelector('a')
    if (paginationLinkElement === null || typeof paginationLinkElement === 'undefined') {
      this.classList.remove('loading')
      return
    }
    const paginationUrl = paginationLinkElement?.getAttribute('href')
    const fetchUrl =
      paginationUrl.indexOf('?') > -1
        ? `${paginationUrl}&sections=main-collection-product-grid`
        : `${paginationUrl}?sections=main-collection-product-grid`

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText
        InfiniteProductGrid.renderProductGrid(JSON.parse(html)['main-collection-product-grid'])
      })
  }

  static renderProductGrid(html) {
    const infiniteProductGrid = document.querySelector('infinite-product-grid')
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
    const productGrid = infiniteProductGrid.querySelector('#product-grid')

    infiniteProductGrid.querySelector('.pagination-wrapper').innerHTML =
      parsedHTML.querySelector('.pagination-wrapper').innerHTML

    const fetchedProductGrid = parsedHTML.querySelector('#product-grid')
    fetchedProductGrid.querySelectorAll('.scroll-trigger').forEach((ele) => {
      ele.classList.remove('scroll-trigger')
    })
    productGrid.innerHTML = productGrid.innerHTML + fetchedProductGrid.innerHTML
    infiniteProductGrid.loading = false
    infiniteProductGrid.classList.remove('loading')

    window.history.pushState('', '', `?page=${fetchedProductGrid.dataset.currnetPage}`)
  }
}
customElements.define('infinite-product-grid', InfiniteProductGrid)

class InfiniteScrollLoadMore extends HTMLElement {
  constructor() {
    super()
    this.querySelector('button').addEventListener('click', this.buttonClickHandler.bind(this))
  }

  buttonClickHandler() {
    if (document.querySelector('infinite-product-grid') !== null) {
      document.querySelector('infinite-product-grid').loadMoreProducts()
    }
  }
}
customElements.define('infinite-scroll-load-more', InfiniteScrollLoadMore)
